import axios from '@/Services/Axios';

/**
 * Submit a request via axios
 *
 * @param method
 * @param url
 * @param data
 * @param config
 * @returns {any}
 */
const Request = function(method, url, data = {}, config = {}) {
    let axiosPromise = null;

    method = method.toLowerCase();
    switch (method) {
        case 'get':
        case 'delete':
        case 'head':
        case 'options':
            axiosPromise = axios[method](url, {
                params: data,
                ...config,
            });
            break;
        case 'post':
        case 'put':
        case 'patch':
            axiosPromise = axios[method](url, data, config);
            break;
        default:
            return Promise.reject(new Error(`Invalid axios method ${method}`));
    }

    return axiosPromise;
};

export default {
    install: (Vue) => {
        /**
         * Submit a GET request.
         *
         * @param url
         * @param data
         * @param config
         * @returns Promise
         */
        Vue.provide('$get', function(url, data = {}, config = {}) {
            return Request('GET', url, data, config);
        });

        /**
         * Submit a DELETE request.
         *
         * @param url
         * @param data
         * @param config
         * @returns Promise
         */
        Vue.provide('$delete', function(url, data = {}, config = {}) {
            return Request('DELETE', url, data, config);
        });

        /**
         * Submit a HEAD request.
         *
         * @param url
         * @param data
         * @param config
         * @returns Promise
         */
        Vue.provide('$head', function(url, data = {}, config = {}) {
            return Request('HEAD', url, data, config);
        });

        /**
         * Submit an OPTION request.
         *
         * @param url
         * @param data
         * @param config
         * @returns Promise
         */
        Vue.provide('$option', function(url, data = {}, config = {}) {
            return Request('OPTION', url, data, config);
        });

        /**
         * Submit a POST request
         *
         * @param url
         * @param data
         * @param config
         * @returns Promise
         */
        Vue.provide('$post', function(url, data = {}, config) {
            return Request('POST', url, data, config);
        });

        /**
         * Submit a PATCH request
         *
         * @param url
         * @param data
         * @param config
         * @returns Promise
         */
        Vue.provide('$patch', function(url, data = {}, config = {}) {
            return Request('PATCH', url, data, config);
        });
    },
};
